import { render, staticRenderFns } from "./StorageInfo.vue?vue&type=template&id=610d9140&scoped=true"
import script from "./StorageInfo.vue?vue&type=script&lang=js"
export * from "./StorageInfo.vue?vue&type=script&lang=js"
import style0 from "./StorageInfo.vue?vue&type=style&index=0&id=610d9140&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610d9140",
  null
  
)

export default component.exports